"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KHInputProviderController = exports.PadAxis = exports.PadInput = void 0;
const KHInputAxis_1 = require("./KHInputAxis");
const KHInputKey_1 = require("./KHInputKey");
const KHInputProvider_1 = require("./KHInputProvider");
const KHUnifiedInput_1 = require("./KHUnifiedInput");
var PadInput;
(function (PadInput) {
    PadInput[PadInput["Left"] = 0] = "Left";
    PadInput[PadInput["Right"] = 1] = "Right";
    PadInput[PadInput["Up"] = 2] = "Up";
    PadInput[PadInput["Down"] = 3] = "Down";
    PadInput[PadInput["A"] = 4] = "A";
    PadInput[PadInput["B"] = 5] = "B";
    PadInput[PadInput["X"] = 6] = "X";
    PadInput[PadInput["Y"] = 7] = "Y";
    PadInput[PadInput["Select"] = 8] = "Select";
    PadInput[PadInput["Start"] = 9] = "Start";
    PadInput[PadInput["L1"] = 10] = "L1";
    PadInput[PadInput["R1"] = 11] = "R1";
})(PadInput = exports.PadInput || (exports.PadInput = {}));
var PadAxis;
(function (PadAxis) {
    PadAxis[PadAxis["LeftStickX"] = 0] = "LeftStickX";
    PadAxis[PadAxis["LeftStickY"] = 1] = "LeftStickY";
    PadAxis[PadAxis["RightStickX"] = 2] = "RightStickX";
    PadAxis[PadAxis["RightStickY"] = 3] = "RightStickY";
})(PadAxis = exports.PadAxis || (exports.PadAxis = {}));
class KHInputProviderController extends KHInputProvider_1.KHInputProvider {
    constructor(scene, gamePadNumber) {
        super();
        this.scene = scene;
        this.gamePadNumber = gamePadNumber;
        this.buttons = new Map();
        this.buttons.set(PadInput.A, new KHInputKey_1.KHInputKey());
        this.buttons.set(PadInput.B, new KHInputKey_1.KHInputKey());
        this.buttons.set(PadInput.X, new KHInputKey_1.KHInputKey());
        this.buttons.set(PadInput.Y, new KHInputKey_1.KHInputKey());
        this.buttons.set(PadInput.Left, new KHInputKey_1.KHInputKey());
        this.buttons.set(PadInput.Right, new KHInputKey_1.KHInputKey());
        this.buttons.set(PadInput.Up, new KHInputKey_1.KHInputKey());
        this.buttons.set(PadInput.Down, new KHInputKey_1.KHInputKey());
        this.buttons.set(PadInput.Start, new KHInputKey_1.KHInputKey());
        this.buttons.set(PadInput.Select, new KHInputKey_1.KHInputKey());
        this.buttons.set(PadInput.L1, new KHInputKey_1.KHInputKey());
        this.buttons.set(PadInput.R1, new KHInputKey_1.KHInputKey());
        this.axis = new Map();
        this.axis.set(PadAxis.LeftStickX, new KHInputAxis_1.KHInputAxis());
        this.axis.set(PadAxis.LeftStickY, new KHInputAxis_1.KHInputAxis());
        this.axis.set(PadAxis.RightStickX, new KHInputAxis_1.KHInputAxis());
        this.axis.set(PadAxis.RightStickY, new KHInputAxis_1.KHInputAxis());
    }
    tryVibrate(delay, duration, weak, strong) {
        let gamepad = this._getGamepad();
        if (!gamepad) {
            return;
        }
        let haptics = gamepad.vibration;
        if (haptics) {
            // playEffect is more flexible, so attempt to use that first
            if (haptics.playEffect) {
                haptics.playEffect('dual-rumble', {
                    startDelay: delay,
                    duration: duration,
                    weakMagnitude: weak,
                    strongMagnitude: strong,
                });
            }
            else if (haptics.pulse) {
                let strength = Math.max(weak, strong);
                haptics.pulse(strength, duration);
            }
        }
    }
    updateDisconnect() {
        this.buttons.forEach((value, key) => {
            value.update(false);
        });
    }
    _getGamepad() {
        if (!this.scene.input.gamepad || this.gamePadNumber >= this.scene.input.gamepad.gamepads.length) {
            this.updateDisconnect();
            return;
        }
        let gamePad = this.scene.input.gamepad.gamepads[this.gamePadNumber];
        if (!gamePad) {
            this.updateDisconnect();
            return;
        }
        return gamePad;
    }
    update(now, delta) {
        let gamePad = this._getGamepad();
        if (!gamePad)
            return;
        this._updateInput(PadInput.A, gamePad.A);
        this._updateInput(PadInput.B, gamePad.B);
        this._updateInput(PadInput.X, gamePad.X);
        this._updateInput(PadInput.Y, gamePad.Y);
        this._updateInput(PadInput.Left, gamePad.left);
        this._updateInput(PadInput.Right, gamePad.right);
        this._updateInput(PadInput.Up, gamePad.up);
        this._updateInput(PadInput.Down, gamePad.down);
        this._updateInput(PadInput.Start, gamePad.getButtonValue(9) == 1);
        this._updateInput(PadInput.Select, gamePad.getButtonValue(8) == 1);
        this._updateInput(PadInput.L1, gamePad.L1 > 0.9);
        this._updateInput(PadInput.R1, gamePad.R1 > 0.9);
        this._updateAxis(PadAxis.LeftStickX, gamePad.leftStick.x);
        this._updateAxis(PadAxis.LeftStickY, gamePad.leftStick.y);
        this._updateAxis(PadAxis.RightStickX, gamePad.rightStick.x);
        this._updateAxis(PadAxis.RightStickY, gamePad.rightStick.y);
    }
    _updateInput(input, value) {
        this.buttons.get(input).update(value);
        if (value) {
            KHUnifiedInput_1.KHUnifiedInput.lastInputSource = this;
        }
    }
    _updateAxis(axis, value) {
        if (this.axis.get(axis).update(value)) {
            KHUnifiedInput_1.KHUnifiedInput.lastInputSource = this;
        }
    }
    getInput(input) {
        return this.buttons.get(input);
    }
    getAxis(axis) {
        return this.axis.get(axis);
    }
    isDown(input) {
        return this.buttons.get(input).isDown();
    }
    isJustDown(input) {
        return this.buttons.get(input).isJustDown();
    }
    type() {
        return KHInputProviderController.INPUT_TYPE;
    }
}
exports.KHInputProviderController = KHInputProviderController;
KHInputProviderController.INPUT_TYPE = "controller";
